import React, {Component} from 'react';
import {connect} from 'react-redux';
import ReactDOM from 'react-dom';

import { UPDATE_USER_DATA} from "actions/actionTypes";
import FacebookLogin from 'react-facebook-login';
import config from  '../../config';

import {   validateEmail   }  from 'util/Utils';

import {Link} from 'react-router';
import {Form, FormGroup, Col, Button, ControlLabel, FormControl, Panel} from 'react-bootstrap';
import {   makeRequest , displayMessage  }  from 'actions';

class Login extends Component {

    constructor(props) {
        super(props)
        this.state = { pending:false}
    }
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    signinWithPassword(e) {
        e.preventDefault();
        var email = ReactDOM.findDOMNode(this.refs.formHorizontalEmail).value;
        var password = ReactDOM.findDOMNode(this.refs.formHorizontalPassword).value;

        if (email == '' ) {

            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please, specify your email address'
            });
        }
        if (!validateEmail(email)) {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Email is not valid'
            });
        }
        if ( password == '' ) {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please, specify your password'
            });
        }
        if ( password.length < 3) {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Password should include at least 3 symbols'
            });
        }

        this.setState({
            pending: true
        });
        this.signIn({
            type: 'password',
            email:email ,
            password:password
        });
    }
    loginWithFacebook(params){
        var self = this;
        self.setState({
            pending: true
        });
        self.signIn({
            type: 'facebook',
            accessToken: params.accessToken
        })
    }
    signIn(params){
        var self = this;
        var methodData = {
            "success_event": UPDATE_USER_DATA,
            'endpoint': '/signin ',
            type:'post',
            'not_display_success_message':true,
        };
        self.props.makeRequest(params,methodData).then(function (response) {
            console.log('response.data.User._id',response.data.User._id );
            if (_.size(_.intersection(_.get(response.data, 'User.Roles', []), ['Partner'])) > 0) {
                self.context.router.push('/partner');
            }else {
                self.context.router.push('/admin');
            }
            // if (self.props.appData.redirectToURL) {
            //     window.location.href = self.props.appData.redirectToURL;
            // } else{
            //     browserHistory.replace('/admin')
            // }



        }).catch(function (error) {
            self.setState({
                pending: false
            });
        });
    }

    render() {
        return (
            <div >
                <Panel header="Admin Login Form">
                    <Form horizontal onSubmit={this.signinWithPassword.bind(this)}>
                        <FormGroup >
                            <Col componentClass={ControlLabel} sm={2}>
                                Email
                            </Col>
                            <Col sm={10}>
                                <FormControl type="email" ref="formHorizontalEmail" placeholder="Email"/>
                            </Col>
                        </FormGroup>
                        <FormGroup >
                            <Col componentClass={ControlLabel} sm={2}>
                                Password
                            </Col>
                            <Col sm={10}>
                                <FormControl type="password" ref="formHorizontalPassword" placeholder="Password"/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col smOffset={2} sm={10}>
                                <Button className="btn-primary" type="submit">
                                    Sign in
                                </Button>
                            </Col>
                        </FormGroup>
                    </Form>
                    <div>
                        <FacebookLogin
                        appId={config.facebook.appID}
                        cssClass="pull-left right15 bot15 btn btn-primary"
                        // icon="fa-facebook"
                        //fields="name, picture, email"
                        scope="public_profile, email"
                        //onClick={this.loginWithFacebook}
                        callback={this.loginWithFacebook.bind(this)} />
                        <div className="pull-left">
                            <Button onClick={(event) =>   this.context.router.push('/reset-password')} className="btn-primary" type="button">
                                Forgot password
                            </Button>
                        </div>
                    </div>
                </Panel>
            </div >
        );

    }
}

function mapStateToProps(state) {
    return { appData: state.appData  }
}

export default connect(mapStateToProps, {makeRequest,displayMessage})(Login);
